import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ExternalLink, ArrowUpRight, ArrowDownRight, } from "lucide-react";
import { Link } from "react-router";
import InnerLoader from "../../../../../component/ui/loader/inner-loader";
import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableHead, TableHeaderWrap, TableMaxTags, TableRow } from "../../../../../component/table/table-layout";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";

export default function KpisPopup({ open = true, onClose = () => { }, apiKey, apiUrl, pagUrl, title, icon, subTitle, stateLable, positive = null, positiveIcon = true, }) {
    const containerRef = useRef(null);
    const apiCall = useApiCall();
    const [head, setHead] = useState([]);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getData = async () => {
        setIsLoading(false)
        try {
            const res = await apiCall({ method: "get", url: apiUrl });
            setHead(res?.applied_headers);
            setData(res?.data || []);
            setIsLoading(true);
        } catch (error) {
            console.log("Error : ", error);
        }
    }

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 50);
    }, [apiUrl])

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    className="fixed inset-0 z-[60] flex items-stretch justify-end bg-slate-900/40 backdrop-blur-sm"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <motion.aside
                        ref={containerRef}
                        initial={{ x: 40, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 40, opacity: 0 }}
                        transition={{ type: "spring", stiffness: 380, damping: 32 }}
                        className="relative mt-auto mr-[2vh] mb-auto ml-0 flex h-[96vh] w-[750px] max-w-[98vw] flex-col overflow-hidden rounded-[10px] border border-solid border-slate-200 bg-gradient-to-b from-white to-slate-50 shadow-xl"
                        aria-modal
                        role="dialog"
                    >
                        {
                            isLoading ? (
                                <>
                                    {/* Header */}
                                    <div className="border-b border-solid border-slate-200 bg-white/90 py-2 backdrop-blur supports-[backdrop-filter]:bg-white/70 w-full">
                                        <div className="flex flex-wrap items-center justify-between gap-3 w-full">
                                            <div className="flex min-w-0 items-center gap-3">
                                                <div className="text-lg bg-gradient-to-br from-indigo-500/10 to-emerald-500/10 grid place-items-center font-medium rounded-md w-11 h-11">{icon}</div>
                                                <div className="flex flex-col gap-0">
                                                    <h2 className="truncate text-lg font-semibold tracking-tight text-slate-900 flex gap-2 items-center">
                                                        {title}

                                                        {positive != null && (
                                                            <span
                                                                className={`flex items-center text-xs px-2 py-0.5 rounded-full ${positive
                                                                    ? "bg-green-100 text-green-700"
                                                                    : "bg-red-100 text-red-700"
                                                                    }`}
                                                            >

                                                                {
                                                                    positiveIcon ? (
                                                                        positive ? (
                                                                            <ArrowUpRight className="h-3 w-3 mr-1" />
                                                                        ) : (
                                                                            <ArrowDownRight className="h-3 w-3 mr-1" />
                                                                        )
                                                                    ) : null
                                                                }
                                                                {stateLable}
                                                            </span>
                                                        )}
                                                    </h2>
                                                    <p className="text-sm text-slate-400">{subTitle}</p>
                                                </div>
                                            </div>

                                            <div className="flex flex-wrap items-center gap-2">
                                                <Link
                                                    to={`${pagUrl}`}
                                                    className="inline-flex items-center gap-1.5 rounded-xl border border-solid border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                                                // onClick={() => window.alert("Opening full profile… (wire to route)")}
                                                >
                                                    <ExternalLink className="size-4" /> View Full
                                                </Link>
                                                <button
                                                    className="inline-flex items-center gap-1.5 rounded-xl bg-[#0B54FF] px-3 py-2 text-sm font-medium text-white hover:bg-[#0849e0]"
                                                    onClick={onClose}
                                                    aria-label="Close"
                                                >
                                                    <X className="size-4" /> Exit
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Body */}
                                    <div className="grid min-h-0 flex-1 grid-cols-1 gap-4 overflow-hidden py-[10px] w-full">
                                        <TableCard>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        {/* <TableCell header><TableHeaderWrap><span>Name</span></TableHeaderWrap></TableCell> */}
                                                        {head.map((ele, idx) => {

                                                            return (
                                                                <TableCell header key={`th-${idx}`}><TableHeaderWrap><span>{ele?.value}</span></TableHeaderWrap></TableCell>
                                                            )

                                                        })}
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {data.map((ele, idx) => (
                                                        <TableRow key={ele.id || idx}>
                                                            {/* <TableCell>
                                                                --
                                                            </TableCell> */}
                                                            {
                                                                head.map((h_ele, h_idx) => (
                                                                    <TableCell key={`td-${h_idx}`}>
                                                                        {ele?.[h_ele?.key] ?? "--"}
                                                                    </TableCell>
                                                                ))
                                                            }
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableCard>
                                    </div>
                                </>
                            ) : (
                                <InnerLoader wrapperClass={'w-full'} />
                            )
                        }

                    </motion.aside>
                </motion.div>
            )}
        </AnimatePresence>
    );
}